import Vue from 'vue';
import { ISort } from '@/entities/sort.interface';
import { ICriterion } from '@/entities/criterion.interface';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import queryService from '@/services/query.service';

export abstract class MasterPage extends Vue {
    public loading: boolean = false;

    public total: number = 0;

    get page(): number {
        return queryService.getPage(this.$route);
    }

    get pageSize(): number {
        return queryService.getPageSize(this.$route);
    }

    get sort(): ISort {
        return queryService.getSort(this.$route, this.defaultSort);
    }

    protected abstract defaultSort: ISort;

    get pageBaseIndex() {
        return (this.page - 1) * this.pageSize + 1;
    }

    public sortChange(sort: ISort) {
        queryService.pushChanges(this.$route, this.$router, {
            sort,
            page: 1
        });
    }

    public pageChange(page: number) {
        queryService.pushChanges(this.$route, this.$router, {
            page
        });
    }

    protected pageSortParams() {
        return {
            page: this.page,
            pageSize: this.pageSize,
            sortField: this.sort.field,
            sortAsc: this.sort.asc
        };
    }
}
